const articles = [
    { key: 'service', title: 'Услуги' },
    { key: 'partner', title: 'Партнеры' },
    { key: 'blog', title: 'Блог' },
];

export default articles;
